import { render, staticRenderFns } from "./ssoFail.vue?vue&type=template&id=0332a5d3"
import script from "./ssoFail.vue?vue&type=script&lang=js"
export * from "./ssoFail.vue?vue&type=script&lang=js"
import style0 from "./ssoFail.vue?vue&type=style&index=0&id=0332a5d3&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0332a5d3')) {
      api.createRecord('0332a5d3', component.options)
    } else {
      api.reload('0332a5d3', component.options)
    }
    module.hot.accept("./ssoFail.vue?vue&type=template&id=0332a5d3", function () {
      api.rerender('0332a5d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/ssoFail.vue"
export default component.exports